import { ReceiptRecoveryMockPreviewState } from 'src/app/TransactionDetail/receiptRecoveryPreview'

export type ReceiptRecoveryMockActivityText =
  | 'Receipt Agent'
  | 'Requested a receipt from the cardholder'
  | 'Run #1'
  | 'Recovered ACME_HOTEL_0418.pdf'
  | 'From the organisation’s Google Workspace mail · run #4'
  | 'No receipt was found in connected sources'
  | 'Run #4'
  | 'Local preview'
  | 'Confirmed the receipt matches this transaction'
  | 'Receipt Reconciled'

export interface ReceiptRecoveryMockActivity {
  id: string
  actor: {
    type: 'RECEIPT_AGENT' | 'USER'
    displayName: ReceiptRecoveryMockActivityText
  }
  occurredAt: string
  title: ReceiptRecoveryMockActivityText
  detail?: ReceiptRecoveryMockActivityText
}

const requestedReceipt: ReceiptRecoveryMockActivity = {
  id: 'receipt-agent-requested',
  actor: {
    type: 'RECEIPT_AGENT',
    displayName: 'Receipt Agent',
  },
  occurredAt: '2026-04-18T12:14:00Z',
  title: 'Requested a receipt from the cardholder',
  detail: 'Run #1',
}

const recoveredReceipt: ReceiptRecoveryMockActivity = {
  id: 'receipt-agent-recovered',
  actor: {
    type: 'RECEIPT_AGENT',
    displayName: 'Receipt Agent',
  },
  occurredAt: '2026-04-22T12:14:00Z',
  title: 'Recovered ACME_HOTEL_0418.pdf',
  detail: 'From the organisation’s Google Workspace mail · run #4',
}

const missingReceipt: ReceiptRecoveryMockActivity = {
  id: 'receipt-agent-missing',
  actor: {
    type: 'RECEIPT_AGENT',
    displayName: 'Receipt Agent',
  },
  occurredAt: '2026-04-22T12:14:00Z',
  title: 'No receipt was found in connected sources',
  detail: 'Run #4',
}

const confirmedReceipt: ReceiptRecoveryMockActivity = {
  id: 'receipt-agent-confirmed',
  actor: {
    type: 'USER',
    displayName: 'Local preview',
  },
  occurredAt: '2026-04-23T13:12:00Z',
  title: 'Confirmed the receipt matches this transaction',
  detail: 'Receipt Reconciled',
}

export const getReceiptRecoveryMockActivities = (
  previewState: ReceiptRecoveryMockPreviewState,
): ReceiptRecoveryMockActivity[] => {
  switch (previewState) {
    case 'waiting-on-spender':
      return [requestedReceipt]
    case 'missing-receipt':
      return [missingReceipt, requestedReceipt]
    case 'needs-review':
      return [recoveredReceipt, requestedReceipt]
    case 'receipt-rejected':
      return [recoveredReceipt, requestedReceipt]
    case 'receipt-reconciled':
    case 'receipt-reconciled-compact':
      return [confirmedReceipt, recoveredReceipt, requestedReceipt]
  }
}
